import JsonLd from '../JsonLd';

const OrganizationSchema: React.FC = () => {
  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "BoardSight AI",
    "alternateName": "BoardSight",
    "description": "BoardSight AI provides comprehensive AI governance training and frameworks for board directors, helping organizations navigate the complex landscape of artificial intelligence oversight.",
    "url": "https://boardsight.ai",
    "logo": "https://qcgnklqgyzwvjrmhzwfj.supabase.co/storage/v1/object/public/assets/favicon.png",
    "image": "https://qcgnklqgyzwvjrmhzwfj.supabase.co/storage/v1/object/public/assets/og-image.png",
    "foundingDate": "2024",
    "sameAs": [
      "https://www.linkedin.com/company/boardsight-ai"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["English"]
    },
    "areaServed": {
      "@type": "Place",
      "name": "Worldwide"
    },
    "knowsAbout": [
      "AI Governance",
      "Board Governance",
      "Artificial Intelligence",
      "Corporate Governance",
      "AI Risk Management",
      "EU AI Act",
      "AI Ethics",
      "Fiduciary Duty",
      "AI Compliance"
    ]
  };

  return <JsonLd data={organizationData} />;
};

export default OrganizationSchema;
